if (!customElements.get('step-slider-1')) {
  customElements.define('step-slider-1',
    class StepSlider1 extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          items: '.cmr__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`) || this.closest('.section');
        this.itemsEl = this.querySelector(this.selectors.items);

        this.mobileItems = this.dataset.mobileItems || '1.5';
        this.tabletItems = this.dataset.tabletItems || '2.5';
        this.desktopItems = this.dataset.desktopItems || '3.5';

        this.sliderInstance = false;

        if (!this.itemsEl) return;

        this.init();
        this.handleRadioSelection();

        window.addEventListener(
          'resize',
          FoxTheme.utils.debounce(() => this.reinit(), 100)
        );
      }

      init() {
        if (typeof this.sliderInstance === 'object') return;

       
        const sliderOptions = {
          slidesPerView: this.mobileItems,
          watchOverflow: true,
          slidesPerGroup: 1,
          navigation: {
            nextEl: this.section?.querySelector(this.selectors.nextEl),
            prevEl: this.section?.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.section?.querySelector('.swiper-pagination'),
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems,
            },
            1024: {
              slidesPerView: this.desktopItems,
            },
            1280: {
              slidesPerView: this.desktopItems,
            },
          },
          loop: false,
          threshold: 2,
          on: {
            init: () => this.equalizeSlideHeights(),
          },
        };

        this.classList.add(this.classes.swiper);
        this.itemsEl.classList.remove(this.classes.grid);
        this.itemsEl.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        this.equalizeSlideHeights();
      }

      reinit() {
        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy(true, true);
          this.sliderInstance = false;
          this.itemsEl.classList.remove(this.classes.swiperWrapper);
          this.itemsEl.classList.add(this.classes.grid);
        }
        this.init();
      }

      // ✅ Equal height slides
      equalizeSlideHeights() {
        
        const slides = this.querySelectorAll('.swiper-slide');
        let maxHeight = 0;
        slides.forEach((slide) => {
          slide.style.height = 'auto';
          maxHeight = Math.max(maxHeight, slide.offsetHeight);
        });
        slides.forEach((slide) => (slide.style.height = `${maxHeight}px`));
      }

      // ✅ Radio click scrolls selected slide into full view
      handleRadioSelection() {
        const radios = this.querySelectorAll('input[type="radio"]');
        radios.forEach((radio) => {
          radio.addEventListener('change', () => {
            const selectedSlide = radio.closest('.swiper-slide');
            if (selectedSlide && this.sliderInstance?.slider) {
              const index = Array.from(
                this.querySelectorAll('.swiper-slide')
              ).indexOf(selectedSlide);
              if (index !== -1) {
                this.sliderInstance.slider.slideTo(index);
              }
            }
          });
        });
      }
    }
  );
}

// Steps controller (prev button + dots)
  (function () {
    function initStepsController(root) {
      const container = root.querySelector('.bundle-steps');
      if (!container) return;
      if (container.dataset.stepsControllerInitialized === 'true') return;
      container.dataset.stepsControllerInitialized = 'true';

      const steps = Array.from(container.children).filter((child) =>
        child.hasAttribute('step')
      );
      if (!steps.length) return;

      const backBtn = container.querySelector('.bundle-steps-controlls__back');
      const dotsWrap = container.querySelector('.bundle-steps-controlls__dots');
      const dotsInputs = dotsWrap
        ? Array.from(dotsWrap.querySelectorAll('input[type="radio"]'))
        : [];
      const numbersEl = dotsWrap?.querySelector('.dots__numbers') || container.querySelector('.dots__numbers');

      // Single loading overlay spanning both columns
      const columnsWrapper = root.querySelector('.product') || root;
      ensureLoadingStylesInjected();
      let overlayEl = null;
      function getOverlay() {
        if (overlayEl && overlayEl.isConnected) return overlayEl;
        overlayEl = document.createElement('div');
        overlayEl.className = 'bundle-loading-overlay';
        const spinner = document.createElement('div');
        spinner.className = 'bundle-loading-spinner';
        // Inline fallback styles (in case CSS hasn't loaded yet)
        spinner.style.width = '36px';
        spinner.style.height = '36px';
        spinner.style.borderRadius = '50%';
        spinner.style.display = 'block';
        spinner.style.border = '3px solid rgba(0,0,0,0.2)';
        spinner.style.borderTopColor = 'rgba(0,0,0,0.65)';
        spinner.style.animation = 'bundle-spin 0.8s linear infinite';
        overlayEl.style.display = 'none';
        overlayEl.style.alignItems = 'center';
        overlayEl.style.justifyContent = 'center';
        overlayEl.style.position = 'absolute';
        overlayEl.style.inset = '0';
        overlayEl.style.background = 'rgba(255,255,255,0.8)';
        overlayEl.style.zIndex = '9999';
        overlayEl.appendChild(spinner);
        if (columnsWrapper) {
          const prevPos = getComputedStyle(columnsWrapper).position;
          if (prevPos === 'static' || !prevPos) {
            columnsWrapper.style.position = 'relative';
          }
          columnsWrapper.appendChild(overlayEl);
        } else {
          document.body.appendChild(overlayEl);
        }
        return overlayEl;
      }
      function setLoading(isLoading) {
        const el = getOverlay();
        el.style.display = isLoading ? 'flex' : 'none';
      }

      const total = steps.length;
      let current = 1;

      function setupQuantityTrackingForStep(stepNumber, levelClass) {
        const stepEl = container.querySelector(`[step="${stepNumber}"]`);
        if (!stepEl) return;

        const quantityInputs = stepEl.querySelectorAll('.bundle-quantity-input');
        quantityInputs.forEach((input) => {
          ['focus', 'change', 'input'].forEach((eventType) => {
            input.addEventListener(
              eventType,
              () => {
                input.dataset.interacted = 'true';
              },
              { once: false }
            );
          });
        });

        const levelRadios = stepEl.querySelectorAll(`.${levelClass}`);
        levelRadios.forEach((radio) => {
          radio.addEventListener('change', () => {
            // Clear interaction flags when switching products
            quantityInputs.forEach((input) => {
              delete input.dataset.interacted;
            });

            const selectedRadio = stepEl.querySelector(`.${levelClass}:checked`);
            quantityInputs.forEach((input) => {
              const inputRadio = input
                .closest('.bundle-product-item_inner')
                ?.querySelector(`.${levelClass}`);
              if (inputRadio && inputRadio !== selectedRadio) {
                input.value = '0';
              }
            });
          });
        });
      }

      function setupQuantityTracking() {
        // Step 2: main area selection
        setupQuantityTrackingForStep(2, 'product_level_2');
        // Step 3: edge rails
        setupQuantityTrackingForStep(3, 'product_level_3');
        // Step 4: support rails
        setupQuantityTrackingForStep(4, 'product_level_4');
      }

      function validateStepQuantity(stepNumber, levelClass, message) {
        if (current !== stepNumber) return true;

        const stepEl = container.querySelector(`[step="${stepNumber}"]`);
        if (!stepEl) return true;

        const selectedRadio = stepEl.querySelector(`.${levelClass}:checked`);
        if (!selectedRadio) return true;

        const quantityInput = selectedRadio
          .closest('.bundle-product-item_inner')
          ?.querySelector('.bundle-quantity-input');
        if (!quantityInput) return true;

        if (quantityInput.dataset.interacted !== 'true') {
          alert(message);
          return false;
        }

        const qty = parseInt(quantityInput.value, 10);
        if (!Number.isFinite(qty) || qty <= 0) {
          alert(message);
          return false;
        }

        return true;
      }

      function validateCurrentStepQuantity() {
        if (current === 2) {
          return validateStepQuantity(
            2,
            'product_level_2',
            'Husk at vælge hvor mange m2 du skal bruge'
          );
        }
        if (current === 3) {
          return validateStepQuantity(
            3,
            'product_level_3',
            'Husk at vælge antal for dette trin'
          );
        }
        if (current === 4) {
          return validateStepQuantity(
            4,
            'product_level_4',
            'Husk at vælge antal for dette trin'
          );
        }
        return true;
      }

      // Initialize quantity tracking
      setupQuantityTracking();

      // Next buttons
      const nextButtons = container.querySelectorAll('.bundle-steps-next-btn');
      
      // Update Next button states based on current step
      function updateNextButtons() {
        nextButtons.forEach((btn) => {
          const btnStep = parseInt(btn.getAttribute('data-step'), 10);
          if (btnStep === current) {
            if (current === total) {
              btn.classList.add('is-disabled');
              btn.disabled = true;
            } else {
              btn.classList.remove('is-disabled');
              btn.disabled = false;
            }
          }
        });
      }

      // Set up Next button click handlers
      nextButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const btnStep = parseInt(btn.getAttribute('data-step'), 10);
          if (!isNaN(btnStep) && btnStep === current && current < total) {
            // Validate quantity interaction before moving forward
            if (!validateCurrentStepQuantity()) {
              return;
            }
            showStep(current + 1);
          }
        });
      });

      function showStep(stepIndex, withLoading = true) {
        current = Math.min(Math.max(stepIndex, 1), total);
        const switchContent = () => {
          steps.forEach((el) => {
            const s = parseInt(el.getAttribute('step'), 10);
            el.style.display = s === current ? '' : 'none';
          });
          if (numbersEl) numbersEl.textContent = `${current}/${total}`;
          dotsInputs.forEach((inp) => (inp.checked = String(current) === inp.value));
          if (backBtn) backBtn.classList.toggle('is-disabled', current === 1);
          // Update URL hash
          try { history.replaceState(null, '', `#step${current}`); } catch (e) {}

          // Re-init any sliders in the now-visible step (hidden-at-load fix)
          const visibleStep = container.querySelector(`[step="${current}"]`);
          if (visibleStep) {
            const sliders = visibleStep.querySelectorAll('step-slider-1');
            sliders.forEach((sl) => {
              if (typeof sl.reinit === 'function') {
                setTimeout(() => sl.reinit(), 0);
              } else if (typeof sl.reinitialize === 'function') {
                setTimeout(() => sl.reinitialize(), 0);
              }
            });
          }

          // Also show matching .bundle-info .step_info
          const infoBox = root.querySelector('.bundle-info');
          if (infoBox) {
            const infoBlocks = infoBox.querySelectorAll('.step_info');
            infoBlocks.forEach((el) => {
              const s = parseInt(el.getAttribute('step'), 10);
              el.style.display = s === current ? '' : 'none';
            });
          }

          // Update level products visibility based on current selections when step becomes visible
          if (typeof window.updateBundleLevels === 'function') {
            setTimeout(() => {
              window.updateBundleLevels(root);
            }, 50);
          }

          // Re-setup quantity tracking when quantity steps (2–4) become visible
          if (current === 2 || current === 3 || current === 4) {
            setTimeout(() => {
              setupQuantityTracking();
            }, 100);
          }

          // Update Next button states
          updateNextButtons();
        };

        if (withLoading) {
          setLoading(true);
          setTimeout(() => {
            switchContent();
            setLoading(false);
          }, 1200); // 1.2s fake loading
        } else {
          switchContent();
        }
      }

      // Prev button
      if (backBtn) backBtn.addEventListener('click', () => {
        if (current === 1) return; // do nothing on first step
        showStep(current - 1);
      });

      // Dots
      dotsInputs.forEach((inp) => {
        inp.addEventListener('change', () => {
          const val = parseInt(inp.value, 10);
          if (!isNaN(val) && val !== current) {
            // Validate quantity interaction only when moving forward
            if (val > current && !validateCurrentStepQuantity()) {
              // Revert the dot selection
              inp.checked = false;
              const currentDot = dotsInputs.find(
                (d) => d.value === String(current)
              );
              if (currentDot) currentDot.checked = true;
              return;
            }
            showStep(val);
          }
        });
      });

      // Init (read #stepN from URL if present)
      const hash = (location.hash || '').toLowerCase();
      const match = hash.match(/^#step(\d+)$/);
      if (match) {
        const initial = parseInt(match[1], 10);
        if (!isNaN(initial)) current = Math.min(Math.max(initial, 1), total);
      }
      showStep(current, false);
    }

    // document.addEventListener('DOMContentLoaded', () => {
    //   // Initialize for all sections using this feature
    //   document.querySelectorAll('.bundle-page').forEach((root) => initStepsController(root));
    // });
    function initSteps() {
      document.querySelectorAll('.bundle-page').forEach((root) => initStepsController(root));
    }

    // Run on normal page load
    document.addEventListener('DOMContentLoaded', initSteps);
    document.addEventListener('shopify:section:load', initSteps);
    document.addEventListener('shopify:section:select', initSteps);

    // Inject minimal CSS for loading overlays once
    function ensureLoadingStylesInjected() {
      const existing = document.getElementById('bundle-steps-loading-styles');
      const css = `
        .bundle-loading-overlay{position:absolute;inset:0;display:none;align-items:center;justify-content:center;background:rgba(255,255,255,0.8);z-index:9999;pointer-events:all}
        .bundle-loading-spinner{width:36px;height:36px;border-radius:50%;border:3px solid rgba(0,0,0,0.2);border-top-color:rgba(0,0,0,0.65);animation:bundle-spin 0.8s linear infinite}
        @keyframes bundle-spin { to { transform: rotate(360deg); } }
      `;
      if (existing) {
        if (!existing.textContent.includes('.bundle-loading-overlay')) {
          existing.textContent = css;
        }
        return;
      }
      const style = document.createElement('style');
      style.id = 'bundle-steps-loading-styles';
      style.textContent = css;
      document.head.appendChild(style);
    }
  })();

// Multi-level product selection handler
(function() {
  function initMultiLevelSelection(root) {
    if (!root) return;
    if (root.dataset.bundleLevelsInitialized === 'true') return;
    root.dataset.bundleLevelsInitialized = 'true';

    // Handle radio button changes for each level
    // Load saved selections once for this section (used to avoid overriding restored choice)
    try {
      const sectionId = root.getAttribute('data-section') || root.id || 'bundle';
      const storageKey = `bundleSelections:${sectionId}`;
      const saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
      if (saved) root._savedSelections = saved;
    } catch (e) {}

    function ensureDefaultRadio(container, selector) {
      if (!container) return;

      if (container.dataset && container.dataset.allowsMultiple === 'true') {
        return;
      }
      // If something is already checked in this container, keep it
      const checked = container.querySelector(`${selector}:checked`);
      if (checked) return;

      // If we have a saved selection for this level and it exists in this container, prefer it
      const m = selector.match(/product_level_(\d+)/);
      const level = m && m[1] ? m[1] : null;
      if (level && root._savedSelections && root._savedSelections[level]) {
        const savedEntry = root._savedSelections[level];
        let savedValues = [];
        if (Array.isArray(savedEntry)) {
          savedValues = savedEntry;
        } else if (typeof savedEntry === 'object' && savedEntry !== null) {
          if (savedEntry.value) savedValues.push(savedEntry.value);
          if (savedEntry.id) savedValues.push(savedEntry.id);
          if (savedEntry.values && Array.isArray(savedEntry.values)) {
            savedValues = savedValues.concat(savedEntry.values);
          }
        } else if (savedEntry !== null && savedEntry !== undefined) {
          savedValues.push(savedEntry);
        }
        const match = savedValues
          .map((val) => container.querySelector(`${selector}[value="${val}"]`))
          .find((el) => el);
        if (match) {
          match.checked = true;
          match.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }

      // Otherwise, fall back to the first available radio in this container
      const first = container.querySelector(selector);
      if (first) {
        first.checked = true;
        first.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function handleLevelChange(level, currentProductId) {
      // Level 2 selection affects levels 3, 4, and 5 (they all depend on level 2 product)
         if (level === 2) {
        // Update level 3
        const level3Container = root.querySelector(`.step3, .level-3, [step="3"]`);
        if (level3Container) {
          const level3Products = level3Container.querySelectorAll('.level_products');
          level3Products.forEach((container) => {
            const containerProductId = container.getAttribute('data-product');
            if (containerProductId && containerProductId === String(currentProductId)) {
              container.style.display = '';
              // Ensure a default selection exists
              ensureDefaultRadio(container, '.product_level_3');
            } else {
              container.style.display = 'none';
                 // Uncheck any radios inside hidden containers
                 const radios = container.querySelectorAll('input[type="radio"], input[type="checkbox"]');
                 radios.forEach((r) => { if (r.checked) r.checked = false; });
            }
          });
        }
        
        // Update level 4
        const level4Container = root.querySelector(`.step4, .level-4, [step="4"]`);
        if (level4Container) {
          const level4Products = level4Container.querySelectorAll('.level_products');
          level4Products.forEach((container) => {
            const containerProductId = container.getAttribute('data-product');
            if (containerProductId && containerProductId === String(currentProductId)) {
              container.style.display = '';
              ensureDefaultRadio(container, '.product_level_4');
            } else {
              container.style.display = 'none';
                 const radios = container.querySelectorAll('input[type="radio"], input[type="checkbox"]');
                 radios.forEach((r) => { if (r.checked) r.checked = false; });
            }
          });
        }
        
        // Update level 5
        const level5Container = root.querySelector(`.step5, .level-5, [step="5"]`);
        if (level5Container) {
          const level5Products = level5Container.querySelectorAll('.level_products');
          level5Products.forEach((container) => {
            const containerProductId = container.getAttribute('data-product');
            if (containerProductId && containerProductId === String(currentProductId)) {
              container.style.display = '';
              if (container.dataset.allowsMultiple === 'true') {
                if (!container.querySelector('.product_level_5:checked')) {
                  const noneOption = container.querySelector('.product_level_5[data-none-option="true"]');
                  if (noneOption) {
                    noneOption.checked = true;
                    noneOption.dispatchEvent(new Event('change', { bubbles: true }));
                  }
                }
              } else {
                ensureDefaultRadio(container, '.product_level_5');
              }
            } else {
              container.style.display = 'none';
                 const radios = container.querySelectorAll('input[type="radio"], input[type="checkbox"]');
                 radios.forEach((r) => { if (r.checked) r.checked = false; });
            }
          });
        }
        return;
      }

      // For level 1, update level 2
         if (level === 1) {
         const nextLevel = level + 1;
         const nextLevelContainer = root.querySelector(`.step${nextLevel}, .level-${nextLevel}, [step="${nextLevel}"]`);
        
        if (!nextLevelContainer) return;

         const levelProducts = nextLevelContainer.querySelectorAll('.level_products');
        
        if (levelProducts.length === 0) return;

         let anyMatched = false;
         levelProducts.forEach((container) => {
          const containerProductId = container.getAttribute('data-product');
          if (containerProductId && containerProductId === String(currentProductId)) {
            container.style.display = '';
            ensureDefaultRadio(container, `.product_level_${nextLevel}`);
             anyMatched = true;
          } else {
               container.style.display = 'none';
                 const radios = container.querySelectorAll('input[type="radio"], input[type="checkbox"]');
                 radios.forEach((r) => { if (r.checked) r.checked = false; });
                 // Reset quantity inputs for hidden products to 0
                 if (nextLevel === 2) {
                   const quantityInputs = container.querySelectorAll('.bundle-quantity-input');
                   quantityInputs.forEach((input) => {
                     input.value = '0';
                     delete input.dataset.interacted;
                   });
                 }
          }
        });

         // If no container matched for step 2, clear dependent steps 3-5 as well
         if (!anyMatched && nextLevel === 2) {
           for (let step = 3; step <= 5; step++) {
             const depContainer = root.querySelector(`.step${step}, .level-${step}, [step="${step}"]`);
             if (!depContainer) continue;
             depContainer.querySelectorAll('.level_products').forEach((lp) => {
               lp.style.display = 'none';
               const radios = lp.querySelectorAll('input[type="radio"], input[type="checkbox"]');
               radios.forEach((r) => { if (r.checked) r.checked = false; });
             });
           }
         }
      }
    }

    // Store handleLevelChange on the root element for later access
    root._handleLevelChange = handleLevelChange;

    // Listen for changes on level 1 radio buttons
    const level1Radios = root.querySelectorAll('.product_level_1');
    level1Radios.forEach((radio) => {
      radio.addEventListener('change', function() {
        const productId = this.getAttribute('data-product-id');
        if (productId) {
          handleLevelChange(1, productId);
        }
      });
    });

    // Listen for changes on level 2 radio buttons
    const level2Radios = root.querySelectorAll('.product_level_2');
    level2Radios.forEach((radio) => {
      radio.addEventListener('change', function() {
        const productId = this.getAttribute('data-product-id');
        if (productId) {
          handleLevelChange(2, productId);
        }
      });
    });

    // Listen for changes on level 3 radio buttons
    // Note: Level 3 selection doesn't affect other levels - levels 3, 4, and 5 all depend on level 2
    const level3Radios = root.querySelectorAll('.product_level_3');
    level3Radios.forEach((radio) => {
      radio.addEventListener('change', function() {
        // Level 3 selection is independent - no need to update other levels
        // Levels 3, 4, and 5 all depend on level 2 selection, not on each other
      });
    });

    // Listen for changes on level 4 radio buttons
    // Note: Level 4 selection doesn't affect other levels - levels 3, 4, and 5 all depend on level 2
    const level4Radios = root.querySelectorAll('.product_level_4');
    level4Radios.forEach((radio) => {
      radio.addEventListener('change', function() {
        // Level 4 selection is independent - no need to update other levels
      });
    });

    // Listen for changes on level 5 radio buttons
    // Note: Level 5 selection doesn't affect other levels - levels 3, 4, and 5 all depend on level 2
    const level5Radios = root.querySelectorAll('.product_level_5');
    level5Radios.forEach((radio) => {
      radio.addEventListener('change', function() {
        // Level 5 selection is independent - no need to update other levels
      });
    });

    // Initialize on page load - sync levels based on currently selected radios
    function initializeLevels() {
      // Start from level 1
      const level1Radio = root.querySelector('.product_level_1:checked');
      if (level1Radio) {
        const productId = level1Radio.getAttribute('data-product-id');
        if (productId) {
          handleLevelChange(1, productId);
        }
      }
    }

    // Run initialization after a short delay to ensure DOM is ready
    setTimeout(initializeLevels, 100);

  }

  // Expose update function globally so it can be called when steps change
  window.updateBundleLevels = function(rootElement) {
    const handleLevelChange = rootElement?._handleLevelChange;
    if (handleLevelChange) {
      const level1Radio = rootElement.querySelector('.product_level_1:checked');
      if (level1Radio) {
        const productId = level1Radio.getAttribute('data-product-id');
        if (productId) {
          handleLevelChange(1, productId);
        }
      }
    }
  };

  function initBundleLevelSelectors() {
    document.querySelectorAll('.bundle-page').forEach((root) => {
      initMultiLevelSelection(root);
    });
  }

  document.addEventListener('DOMContentLoaded', initBundleLevelSelectors);
  document.addEventListener('shopify:section:load', initBundleLevelSelectors);
  document.addEventListener('shopify:section:select', initBundleLevelSelectors);
})();

// Selection list and add to cart handler
(function() {
  function initSelectionList(root) {
    if (!root) return;
    if (root.dataset.bundleSelectionInitialized === 'true') return;
    root.dataset.bundleSelectionInitialized = 'true';

    const selectionList = root.querySelector('.selection_list');
    const selectionTotal = root.querySelector('.selection_total');
    const selectionTotalPrice = root.querySelector('.selection_total__price');
    const addToCartBtn = root.querySelector('.bundle-add-to-cart-btn');
    const atcForm = root.querySelector('.bundle-steps-atc-form');
    const itemsContainer = root.querySelector('.bundle-steps-atc-form .items-container');
    const sectionId = root.getAttribute('data-section') || root.id || 'bundle';
    const storageKey = `bundleSelections:${sectionId}`;
    const bundleSteps = root.querySelector('.bundle-steps');

    if (!selectionList || !selectionTotal || !selectionTotalPrice || !addToCartBtn) return;

    function saveSelections() {
      const payload = {};
      const level1 = root.querySelector('.product_level_1:checked');
      if (level1) payload[1] = level1.value;

      const level2 = root.querySelector('.product_level_2:checked');
      if (level2) {
        const quantity = getQuantityForInput(level2);
        payload[2] = { value: level2.value, quantity };
      }

      const level3 = root.querySelector('.product_level_3:checked');
      if (level3) {
        const quantity = getQuantityForInput(level3);
        payload[3] = { value: level3.value, quantity };
      }

      const level4 = root.querySelector('.product_level_4:checked');
      if (level4) {
        const quantity = getQuantityForInput(level4);
        payload[4] = { value: level4.value, quantity };
      }

      const level5Checked = Array.from(root.querySelectorAll('.product_level_5:checked')).map((input) => {
        return {
          value: input.value,
          quantity: getQuantityForInput(input)
        };
      });
      if (level5Checked.length) {
        payload[5] = level5Checked;
      }

      try { localStorage.setItem(storageKey, JSON.stringify(payload)); } catch (e) {}
    }

      function restoreSelections() {
        let data = null;
        try { data = JSON.parse(localStorage.getItem(storageKey) || 'null'); } catch (e) {}
        if (!data) return;

      if (data[1]) {
        const input = root.querySelector(`.product_level_1[value="${data[1]}"]`);
        if (input) {
          input.checked = true;
          const pid = input.getAttribute('data-product-id');
          if (pid && root._handleLevelChange) root._handleLevelChange(1, pid);
        }
      }

      if (data[2]) {
        let targetValue = data[2];
        let quantity = 0;
        if (typeof data[2] === 'object' && data[2] !== null) {
          if (data[2].value) targetValue = data[2].value;
          if (data[2].id && !targetValue) targetValue = data[2].id;
          if (data[2].quantity !== undefined) {
            const parsedQty = parseInt(data[2].quantity, 10);
            if (Number.isFinite(parsedQty) && parsedQty >= 0) quantity = parsedQty;
          }
        }
        // Wait for level 2 containers to be visible after level 1 is restored
        setTimeout(() => {
          // Try to find the input - it might be in a visible container
          const candidates = Array.from(root.querySelectorAll(`.product_level_2[value="${targetValue}"]`));
          const input = candidates.find((inp) => {
            const container = inp.closest('.level_products');
            return container && container.style.display !== 'none';
          }) || candidates[0];
          
          if (input) {
            input.checked = true;
            const pid = input.getAttribute('data-product-id');
            if (pid && root._handleLevelChange) root._handleLevelChange(2, pid);
            
            // Set quantity AFTER radio change event has been processed
            setTimeout(() => {
              const qtyInput = input.closest('.bundle-product-item_inner')?.querySelector('.bundle-quantity-input');
              if (qtyInput) {
                qtyInput.value = String(quantity);
                // Only mark as interacted if quantity was changed from default (0)
                if (quantity > 0) {
                  qtyInput.dataset.interacted = 'true';
                } else {
                  delete qtyInput.dataset.interacted;
                }
                // Trigger change event to update selection list
                qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }, 150);
          }
        }, 150);
      }

      setTimeout(() => {
        for (let level = 3; level <= 4; level++) {
          const stored = data[level];
          if (!stored) continue;
          let targetValue = stored;
          let quantity = 0;
          if (typeof stored === 'object' && stored !== null) {
            if (stored.value) targetValue = stored.value;
            if (stored.id && !targetValue) targetValue = stored.id;
            if (stored.quantity !== undefined) {
              const parsedQty = parseInt(stored.quantity, 10);
              if (Number.isFinite(parsedQty) && parsedQty >= 0) {
                quantity = parsedQty;
              }
            }
          }
          if (!targetValue) continue;
          const candidates = Array.from(root.querySelectorAll(`.product_level_${level}[value="${targetValue}"]`));
          const target = candidates.find((input) => {
            const container = input.closest('.level_products');
            return container && container.style.display !== 'none';
          });
          if (target) {
            target.checked = true;
            const qtyInput = target.closest('.bundle-product-item_inner')?.querySelector('.bundle-quantity-input');
            if (qtyInput) {
              qtyInput.value = String(quantity);
            }
            target.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        const stored5 = data[5];
        if (stored5) {
          const entries = Array.isArray(stored5) ? stored5 : [stored5];
          entries.forEach((entry) => {
            let val = entry;
            let quantity = 0;
            if (typeof entry === 'object' && entry !== null) {
              if (entry.value) {
                val = entry.value;
              } else if (entry.id) {
                val = entry.id;
              }
              if (entry.quantity !== undefined) {
                const parsedQty = parseInt(entry.quantity, 10);
                if (Number.isFinite(parsedQty) && parsedQty >= 0) {
                  quantity = parsedQty;
                }
              }
            }
            if (!val) return;
            const candidates = Array.from(root.querySelectorAll(`.product_level_5[value="${val}"]`));
            const target = candidates.find((input) => {
              const container = input.closest('.level_products');
              return container && container.style.display !== 'none';
            });
            if (target) {
              target.checked = true;
              const qtyInput = target.closest('.bundle-product-item_inner')?.querySelector('.bundle-quantity-input');
              if (qtyInput) {
                qtyInput.value = String(quantity);
              }
            }
          });
        }

        root.querySelectorAll('.product_level_5').forEach((input) => {
          if (input.checked) {
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }, 0);
      }

    function getQuantityForInput(input) {
      if (!input) return 1;
      const container = input.closest('.bundle-product-item_inner');
      const qtyInput = container?.querySelector('.bundle-quantity-input');
      if (!qtyInput) return 1;
      let qty = parseInt(qtyInput.value, 10);
      const minAttr = parseInt(qtyInput.getAttribute('min'), 10);
      const minValue = Number.isFinite(minAttr) ? minAttr : 0;
      if (!Number.isFinite(qty)) qty = minValue;
      if (qty < minValue) qty = minValue;
      return qty;
    }

    // Get product name and price from input's parent
    function getProductInfo(input) {
      const productItem = input.closest('.bundle-product-item');
      if (!productItem) return null;

      const details = productItem.querySelector('.bundle-product-item__details');
      if (!details) return null;

      const nameEl = details.querySelector('h4, .h6');
      const priceEl = details.querySelector('.price-item');

      const name = nameEl ? nameEl.textContent.trim() : '';
      const priceText = priceEl ? priceEl.textContent.trim() : (input.dataset.priceFormatted || '');
      const variantId = input.value;
      const quantity = getQuantityForInput(input);
      const skip = input.dataset.skip === 'true' || input.value === '__none__';

      // Prefer cents from data attribute
      let priceCents = 0;
      if (input.dataset.priceCents) {
        priceCents = parseInt(input.dataset.priceCents, 10) || 0;
      } else {
        // Fallback: parse from text and convert to cents (best-effort)
        const match = priceText.match(/[\d,.]+/);
        const num = match ? parseFloat(match[0].replace(/,/g, '')) : 0;
        priceCents = Math.round(num * 100);
      }

      return { name, priceCents, priceText, variantId, quantity, skip };
    }

    // Format price for display
    function formatCents(cents) {
      // Prefer FoxTheme's formatter with shop money format
      if (window.FoxTheme && FoxTheme.Currency && typeof FoxTheme.Currency.formatMoney === 'function') {
        const fmt = (window.FoxTheme.settings && window.FoxTheme.settings.moneyFormat) || undefined;
        return FoxTheme.Currency.formatMoney(cents, fmt);
      }
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }
      // Fallback
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((cents || 0) / 100);
    }

    // Update selection list
    function updateSelectionList(currentStep) {
      if (!selectionList) return;

      selectionList.innerHTML = '';
      let totalCents = 0;

      // Show products up to current step
      for (let level = 1; level <= currentStep; level++) {
        if (level === 5) {
          const inputs = Array.from(
            root.querySelectorAll('.product_level_5:checked')
          ).filter((input) => input && input.dataset.skip !== 'true');
          inputs.forEach((input) => {
            const product = getProductInfo(input);
            // Skip if no product name or quantity is zero
            if (!product || !product.name || !product.quantity) return;
            const item = document.createElement('div');
            item.className = 'selection_item';
            const itemTotal = (product.priceCents || 0) * (product.quantity || 1);
            const priceDisplay = formatCents(itemTotal);
            const title = product.quantity > 1 ? `${product.name} × ${product.quantity}` : product.name;
            item.innerHTML = `
              <span class="selection_item__name">${title}</span>
              <span class="selection_item__price">${priceDisplay}</span>
            `;
            selectionList.appendChild(item);
            totalCents += itemTotal;
          });
          continue;
        }

        const input = root.querySelector(`.product_level_${level}:checked`);
        const product = input ? getProductInfo(input) : null;
        // Skip if nothing selected, flagged to skip, or quantity is zero
        if (!product || !product.name || product.skip || !product.quantity)
          continue;
        const item = document.createElement('div');
        item.className = 'selection_item';
        const itemTotal = (product.priceCents || 0) * (product.quantity || 1);
        const priceDisplay = formatCents(itemTotal);
        const title = product.quantity > 1 ? `${product.name} × ${product.quantity}` : product.name;
        item.innerHTML = `
          <span class="selection_item__name">${title}</span>
          <span class="selection_item__price">${priceDisplay}</span>
        `;
        selectionList.appendChild(item);
        totalCents += itemTotal;
      }

      // Update total price
      if (totalCents > 0) {
        selectionTotalPrice.textContent = formatCents(totalCents);
        selectionTotal.style.display = 'flex';
      } else {
        selectionTotal.style.display = 'none';
      }

      // Show add to cart button only on step 5
      if (currentStep === 5) {
        addToCartBtn.style.display = 'block';
      } else {
        addToCartBtn.style.display = 'none';
      }
    }

    function handleSelectionChange() {
      const currentStep = getCurrentStep();
      updateSelectionList(currentStep);
      saveSelections();
    }

    function adjustLevel5Selections(triggerInput) {
      if (!triggerInput) return;
      const container = triggerInput.closest('.level_products');
      if (!container) return;
      const noneOption = container.querySelector('.product_level_5[data-none-option="true"]');
      const activeOptions = Array.from(
        container.querySelectorAll('.product_level_5:not([data-none-option="true"])')
      ).filter((input) => input.checked);

      if (triggerInput.dataset.noneOption === 'true') {
        if (triggerInput.checked) {
          activeOptions.forEach((input) => { input.checked = false; });
        }
      } else {
        if (triggerInput.checked && noneOption) {
          noneOption.checked = false;
        }
      }

      const updatedActiveOptions = Array.from(
        container.querySelectorAll('.product_level_5:not([data-none-option="true"])')
      ).filter((input) => input.checked);

      if (!updatedActiveOptions.length && noneOption) {
        noneOption.checked = true;
      }
      if (updatedActiveOptions.length && noneOption) {
        noneOption.checked = false;
      }
    }

    // Listen for radio/checkbox changes
    function setupRadioListeners() {
      // Level 1
      root.querySelectorAll('.product_level_1').forEach((radio) => {
        radio.addEventListener('change', function() {
          handleSelectionChange();
        });
      });

      // Level 2
      root.querySelectorAll('.product_level_2').forEach((radio) => {
        radio.addEventListener('change', function() {
          handleSelectionChange();
        });
      });

      // Level 3
      root.querySelectorAll('.product_level_3').forEach((radio) => {
        radio.addEventListener('change', function() {
          handleSelectionChange();
        });
      });

      // Level 4
      root.querySelectorAll('.product_level_4').forEach((radio) => {
        radio.addEventListener('change', function() {
          handleSelectionChange();
        });
      });

      // Level 5
      root.querySelectorAll('.product_level_5').forEach((radio) => {
        radio.addEventListener('change', function() {
          adjustLevel5Selections(this);
          handleSelectionChange();
        });
      });

      root.querySelectorAll('.bundle-quantity-input').forEach((input) => {
        input.addEventListener('change', () => {
          const minAttr = parseInt(input.getAttribute('min'), 10);
          const minValue = Number.isFinite(minAttr) ? minAttr : 0;
          let val = parseInt(input.value, 10);
          if (!Number.isFinite(val) || val < minValue) {
            val = minValue;
          }
          input.value = String(val || minValue);
          const level = input.dataset.level || '2';
          const associated = input.closest('.bundle-product-item_inner')?.querySelector(`.product_level_${level}`);
          if (associated && associated.checked) {
            handleSelectionChange();
          } else {
            saveSelections();
          }
        });
      });
    }

    // Get current step number
    function getCurrentStep() {
      // Try to get from the step controller's current value
      const dotsInputs = bundleSteps?.querySelectorAll('.bundle-steps-controlls input[type="radio"][name="active_step[]"]:checked');
      if (dotsInputs && dotsInputs.length > 0) {
        const stepValue = parseInt(dotsInputs[0].value, 10);
        if (!isNaN(stepValue)) {
          return stepValue;
        }
      }
      
      // Fallback: find visible step
      const steps = bundleSteps?.querySelectorAll('[step]');
      if (steps) {
        for (const step of steps) {
          const style = window.getComputedStyle(step);
          if (style.display !== 'none') {
            return parseInt(step.getAttribute('step'), 10) || 1;
          }
        }
      }
      
      return 1;
    }

    // Initialize selected products from checked radios
    function initializeSelections() {
      restoreSelections();
      const currentStep = getCurrentStep();
      updateSelectionList(currentStep);
      saveSelections();
    }

    // Listen for step changes
    function watchStepChanges() {
      // Listen for step navigation via dots
      const stepDots = bundleSteps?.querySelectorAll('.bundle-steps-controlls input[type="radio"][name="active_step[]"]');
      if (stepDots) {
        stepDots.forEach((dot) => {
          dot.addEventListener('change', () => {
            setTimeout(() => {
              const currentStep = getCurrentStep();
              updateSelectionList(currentStep);
            }, 100);
          });
        });
      }

      // Also watch for DOM changes
      const observer = new MutationObserver(() => {
        const currentStep = getCurrentStep();
        updateSelectionList(currentStep);
      });

      if (bundleSteps) {
        observer.observe(bundleSteps, {
          attributes: true,
          attributeFilter: ['style'],
          subtree: true
        });
      }
    }

    // Add to cart functionality
    atcForm?.addEventListener('submit', async function(e) {
      e.preventDefault();
      const button = addToCartBtn;
      const originalText = button.innerHTML;
      button.disabled = true;
      button.innerHTML = '<span class="loading-spinner"></span> Adding to Cart...';

      const selectedInputs = root.querySelectorAll('.product_level_1:checked, .product_level_2:checked, .product_level_3:checked, .product_level_4:checked, .product_level_5:checked');

      const validSelections = Array.from(selectedInputs).filter((input) => input.value && input.value !== '__none__' && input.dataset.skip !== 'true');

      if (validSelections.length === 0) {
        alert('Please select at least one product');
        button.disabled = false;
        button.innerHTML = originalText;
        return;
      }

      // Populate hidden inputs the way theme expects
      if (itemsContainer) itemsContainer.innerHTML = '';
      validSelections.forEach((input) => {
        const idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'items[][id]';
        idInput.value = input.value;
        const qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'items[][quantity]';
        qtyInput.value = String(getQuantityForInput(input));
        itemsContainer?.appendChild(idInput);
        itemsContainer?.appendChild(qtyInput);
      });

      try {
        const formData = new FormData(atcForm);
        const response = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'X-Requested-With': 'XMLHttpRequest' } });

        if (response.ok) {
          button.innerHTML = 'Added!';
          button.style.background = '#28a745';
          
          // Update cart count
          if (typeof window.updateCartCount === 'function') {
            window.updateCartCount();
          }

          // Refresh cart and open drawer
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            detail: { open: true }
          }));

          setTimeout(() => {
            button.disabled = false;
            button.innerHTML = originalText;
            button.style.background = '';
          }, 1500);
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        alert('Failed to add bundle to cart. Please try again.');
        console.error('Bundle add to cart error:', error);
        button.disabled = false;
        button.innerHTML = originalText;
      }
    });

    // Initialize (restore saved selections immediately in order)
    setupRadioListeners();
    watchStepChanges();
    initializeSelections();
    // Sync selection list after restore
    updateSelectionList(getCurrentStep());
  }

  // document.addEventListener('DOMContentLoaded', () => {
  //   document.querySelectorAll('.bundle-page').forEach((root) => {
  //     initSelectionList(root);
  //   });
  // });
  function initBundlePages() {
    document.querySelectorAll('.bundle-page').forEach((root) => {
      initSelectionList(root);
    });
  }

  // Run on normal page load
  document.addEventListener('DOMContentLoaded', initBundlePages);
  // Run inside Shopify Theme Editor (when sections are reloaded)
  document.addEventListener('shopify:section:load', initBundlePages);
  document.addEventListener('shopify:section:select', initBundlePages);
})();


